import scrapRoutes from './routes'

/* @ngInject */
const scrapRun = (
  $transitions,
  maneuverMenu,
  storageHandler,
  $state,
  $$owner,
) => {
  $transitions.onSuccess({
    entering: scrapRoutes.index.path,
  }, (trans) => {
    maneuverMenu.radio.value = 'scrapMenu'

    const step = storageHandler.get('maneuver.scrap.step')

    if (step === 'selectWagons') {
      $state.go(scrapRoutes.selectWagons.path)
    } else if (step === 'createScrapping') {
      $state.go(scrapRoutes.createTrain.path)
    } else if (step === 'report') {
      $state.go(scrapRoutes.report.path)
    } else if (!step) {
      $state.go(scrapRoutes.selectWagons.path)
    }
  })

  $transitions.onBefore({
    from: scrapRoutes.index.path,
  }, (trans) => {

  })

  $transitions.onBefore({
    entering: scrapRoutes.selectWagons.path,
  }, async (trans) => {
    const response = await $$owner.request.getAll()
    $$owner.data.myOwners = response.owners
  })
}

export default scrapRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/scrap/scrap.run.js